import React from 'react';
import Image from 'next/image';

import { Play } from '@/icons/index';

import styles from './PersonCard.module.scss';

const PersonCard = ({
  data,
  showVideo = () => null,
  setVideoPreview = () => null,
}) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = data?.video_link?.match(regExp);
  const videoId = match && match[7].length === 11 ? match[7] : false;

  if (!videoId) {
    return '';
  }

  const onClickHandler = () => {
    showVideo(videoId);
    setVideoPreview(data?.video_thumbnail);
  };

  return (
    <div className={styles.person}>
      <div className={styles.image} onClick={onClickHandler}>
        <Image
          src={data?.video_thumbnail}
          alt={data?.full_name}
          title={data?.full_name}
          loading='lazy'
          layout='fill'
          unoptimized
        />
        <div className={styles.play}>
          <Play />
        </div>
      </div>
      {data?.full_name && data.full_name.trim() !== '' && (
        <div className={styles.name}>{data.full_name}</div>
      )}
      {data?.title && data.title.trim() !== '' && (
        <div className={styles.position}>{data.title}</div>
      )}
      {data?.description && data.description.trim() !== '' && (
        <div className={styles.description}>{data.description}</div>
      )}
    </div>
  );
};

export default PersonCard;
